import { getField, updateField } from 'vuex-map-fields'
import _ from 'lodash'
const defaultFilter = {
  id_regional: [],
  name_regional: "",
  id_branch: [],
  name_branch: "",
  date_1: "",
  date_2: "",
  id_user: [],
  user_create: "",
}

const state = {
  filter: JSON.parse(JSON.stringify(defaultFilter)),
  filterBranchOptions:[],
  filterRegionalOptions:[],
  filterUserOptions:[],
}
const mutations = {
  SET_OPTION_BRANCH(state, data) {
    if (_.isArray(data)) state.filterBranchOptions = data
    else state.filterBranchOptions = [data]
  },
  SET_OPTION_REGIONAL(state, data) {
    if (_.isArray(data)) state.filterRegionalOptions = data
    else state.filterRegionalOptions = [data]
  },
  SET_OPTION_USER(state, data) {
    if (_.isArray(data)) state.filterUserOptions = data
    else state.filterUserOptions = [data]
  },
  updateField
}
const getters = {
  getField,
  isFiltered(state) {
    return !_.isMatch(state.filter,defaultFilter)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
}